module.exports = __webpack_public_path__ + "static/home-product2-d3dec4ea0e5aca55fc5075ca671bf30b.png";